module.exports = __webpack_public_path__ + "img/m-hd.b1d987ba.jpg";